import type { UniclientImage } from './image';
import type { InterpolableTextProps } from './interpolable_text';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export interface CanopyCarrierConfig {
  readonly carrierId: string;
  readonly name: string;
  readonly usernameFieldPlaceholder?: string | null;
  readonly thirdFieldPlaceholder?: string | null;
  readonly thirdFieldValidatorError?: string | null;
  readonly thirdFieldValidatorRgx?: string | null;
  readonly thirdFieldValidatorRgxFlags?: string | null;
  readonly color?: string | null;
  readonly homepageUrl?: string | null;
  readonly createAccountUrl?: string | null;
  readonly resetPasswordUrl?: string | null;
  readonly disablePasswordField: boolean;
  readonly products?: string[] | null;
}
export interface CanopyTokens {
  readonly username: string;
  readonly password?: string;
  readonly thirdfield?: string;
}

export const CANOPY_USERNAME_TOKEN = 'username';
export const CANOPY_PASSWORD_TOKEN = 'password';
export const CANOPY_THIRD_FIELD_TOKEN = 'thirdfield';

export type CanopyTokenInterpolation =
  | typeof CANOPY_PASSWORD_TOKEN
  | typeof CANOPY_THIRD_FIELD_TOKEN
  | typeof CANOPY_USERNAME_TOKEN;

export interface CanopyProps<TComponentAttributes extends string = string> extends UniclientBaseComponentProps {
  readonly attribute: TComponentAttributes;
  readonly tokenMap: Record<string, CanopyTokenInterpolation>;
  readonly carrierConfig: CanopyCarrierConfig;
  readonly disclaimer?: InterpolableTextProps;
  readonly securityImages?: Omit<UniclientImage, 'borderRadius'>[];
  readonly poweredBy?: Omit<UniclientImage, 'borderRadius'>;
}

export type WizardCanopyProps<TComponentAttributes extends string = string> = CanopyProps<TComponentAttributes> &
  UniclientWizardComponentBase<'canopy'>;

export function canopy<TComponentAttributes extends string = string>(
  props: CanopyProps<TComponentAttributes>,
): WizardCanopyProps<TComponentAttributes> {
  return { ...props, type: 'canopy' };
}
